import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

function Contact() {
  return (
    <div id="contatti" className="py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-pink-600 via-transparent to-transparent"></div>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-blue-600 via-transparent to-transparent"></div>
        </div>
      </div>
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-pink-600 via-transparent to-transparent"></div>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-blue-600 via-transparent to-transparent"></div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-pink-400 sm:text-4xl px-4 sm:px-0">
            Contattaci
          </h2>
          <p className="mt-4 text-base sm:text-xl text-gray-600 px-4 sm:px-0">
            Siamo qui per rendere il tuo evento indimenticabile
          </p>
        </div>
        <div className="mt-16 sm:mt-20 grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-2 px-4 sm:px-0">
          <div className="flex flex-col items-center p-8 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 hover:rotate-1 border border-pink-100/50 hover:border-pink-200 relative">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-50/50 to-transparent"></div>
            <div className="relative">
              <Phone className="h-8 w-8 text-pink-600 animate-float" style={{ animationDelay: '0.1s' }} />
              <div className="absolute inset-0 bg-pink-400/20 blur-xl rounded-full animate-pulse"></div>
            </div>
            <h3 className="mt-4 text-xl font-bold text-gray-900">Telefono</h3>
            <p className="mt-2 text-gray-600">+39 327 451 7331</p>
            <a 
              href="https://wa.me/+393274517331"
              target="_blank"
              rel="noopener noreferrer" 
              className="mt-4 text-pink-600 hover:text-pink-700 font-medium group inline-flex items-center hover:scale-105 transition-all duration-300 relative"
            >
              <span className="absolute inset-0 bg-pink-100/50 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
              Scrivici su WhatsApp
              <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
          </div>
          <div className="flex flex-col items-center p-8 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 hover:rotate-1 border border-pink-100/50 hover:border-pink-200 relative">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-50/50 to-transparent"></div>
            <div className="relative">
              <Mail className="h-8 w-8 text-pink-600 animate-float" style={{ animationDelay: '0.2s' }} />
              <div className="absolute inset-0 bg-pink-400/20 blur-xl rounded-full animate-pulse"></div>
            </div>
            <h3 className="mt-4 text-xl font-bold text-gray-900">Email</h3>
            <p className="mt-2 text-gray-600">info@valentinaeventi.it</p>
            <a href="mailto:info@valentinaeventi.it" className="mt-4 text-pink-600 hover:text-pink-700 font-medium group inline-flex items-center hover:scale-105 transition-all duration-300 relative">
              <span className="absolute inset-0 bg-pink-100/50 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
              Invia Email
              <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
          </div>
        </div>
        <div className="mt-16 sm:mt-24 max-w-3xl mx-auto text-center px-4">
          <p className="text-base sm:text-lg text-gray-600">
            Siamo disponibili 7 giorni su 7 per rispondere alle tue domande e aiutarti a organizzare il tuo evento perfetto. Contattaci per una consulenza gratuita!
          </p>
          <div className="mt-8 inline-flex items-center justify-center space-x-2 text-gray-500">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            <span>Online - Risposta in tempo reale</span>
          </div>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4 text-xs sm:text-sm text-gray-500">
            <div className="flex items-center justify-center space-x-2">
              <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
              <span>Preventivi in 24h</span>
            </div>
            <div className="flex items-center justify-center space-x-2">
              <span className="w-2 h-2 bg-green-500 rounded-full"></span>
              <span>Sopralluogo gratuito</span>
            </div>
            <div className="flex items-center justify-center space-x-2">
              <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
              <span>Assistenza dedicata</span>
            </div>
          </div>
          <div className="absolute -bottom-16 -right-16 w-32 h-32 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-float" style={{ animationDelay: '0.7s' }}></div>
          <div className="absolute -bottom-16 -right-32 w-32 h-32 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-float" style={{ animationDelay: '1s' }}></div>
        </div>
      </div>
    </div>
  );
}

export default Contact;